import { render, staticRenderFns } from "./groupFinal1.vue?vue&type=template&id=0c62e991&scoped=true"
import script from "./groupFinal1.vue?vue&type=script&lang=js"
export * from "./groupFinal1.vue?vue&type=script&lang=js"
import style0 from "./groupFinal1.vue?vue&type=style&index=0&id=0c62e991&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62e991",
  null
  
)

export default component.exports